import type { ButtonThemeValues } from '../components/button/button-types';

export const THEME_CONSTANTS: Record<string, ButtonThemeValues> = {
  'danger-link': 'danger-link',
  'high-contrast-link': 'high-contrast-link',
  'pine-text-on-white': 'pine-text-on-white',
  'white-outlined-pine': 'white-outlined-pine',
  'white-outlined': 'white-outlined',
  'shippy-ai': 'shippy-ai',
  danger: 'danger',
  ghost: 'ghost',
  link: 'link',
  primary: 'primary',
  promotional: 'promotional',
  secondary: 'secondary',
  tertiary: 'tertiary',
  unstyled: 'unstyled',
  upsell: 'upsell',
  white: 'white',
};

class ButtonThemeServiceClass {
  getButtonThemes(): ButtonThemeValues[] {
    return [
      THEME_CONSTANTS.primary,
      THEME_CONSTANTS.secondary,
      THEME_CONSTANTS.danger,
      '',
      THEME_CONSTANTS.link,
      THEME_CONSTANTS['high-contrast-link'],
      THEME_CONSTANTS.unstyled,
      THEME_CONSTANTS['danger-link'],
      THEME_CONSTANTS.white,
      THEME_CONSTANTS['white-outlined'],
      THEME_CONSTANTS['white-outlined-pine'],
      THEME_CONSTANTS['pine-text-on-white'],
      THEME_CONSTANTS.promotional,
      THEME_CONSTANTS.tertiary,
      THEME_CONSTANTS.upsell,
      THEME_CONSTANTS.ghost,
      THEME_CONSTANTS['shippy-ai'],
    ];
  }
}

export const ButtonThemeService = new ButtonThemeServiceClass();
